export const getTitleFromSlug = (slug) => {
  if (!slug) return '';

  return slug.replace(/-/g, ' ').toUpperCase();
};
